import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const userRoleApi = createApi({
  reducerPath: 'userRoleApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/api/v1/roles' }),
  endpoints: (builder) => ({
    getUserRoles: builder.query({
      query: (searchParams = '') => ({ url: searchParams }),
      providesTags: ['UserRole']
    }),
    getUserRole: builder.query({
      query: (id) => `/${id}`,
      providesTags: ['UserRole']
    })
  })
})

export const { useGetUserRolesQuery, useGetUserRoleQuery } = userRoleApi
export { userRoleApi }
